export default "__VITE_ASSET__CHwFgAhW__"